import React from 'react'
import { Route, Switch, withRouter, Redirect } from 'react-router-dom'
import { isMobile } from 'react-device-detect'
import PageHOC from '../layout/PageHOC'
import { SERVICE_MOBILE } from '../constants'
import Mobile4GPlans from '../mobile/Mobile4GPlans'
import MobileCoverage from '../mobile/MobileCoverage'
import MobileCharges from '../mobile/MobileCharges'
import MobileRoaming from '../mobile/MobileRoaming'
import MobileInternationalRates from '../mobile/MobileInternationalRates'
import SubNavigationFloating from '../modules/SubNavigationFloating'
import FaqAndTerms from '../modules/FaqAndTerms'
import globals from '../globals'
import ThreeGPolicy from '../mobile/ThreeGPolicy'

class Mobile extends React.Component {
    constructor (props) {
        super(props)

        this.subNav = [
            { title: 'Plans', url: '', icon: '4G.svg' },
            { title: 'Charges', url: '/charges', icon: 'Charges.svg' },
            { title: 'Intl. rates', url: '/international-rates', icon: 'IntlRates.svg' },
            { title: 'Global roaming', url: '/plans-roaming', icon: 'Roaming.svg' },
            !isMobile ? { title: 'Coverage', url: '/coverage', icon: 'Coverage.svg' } : false,
            { title: 'Q&A / Terms', url: '/faq-terms', icon: 'QA.svg' }
        ]

        this.anchor = React.createRef()
    }

    componentDidMount () {
        this.props.delayedAnimateIn()
        globals.pushGA4Events('journeyStep', {
            eventInfo: {
                journeyName: 'Mobile Plans',
                stepName: 'View Mobile plan',
                stepNo: '1'
            }
        })

        globals.pushGA4Events("pageLoad", {
            eventInfo: {
                pageName: "Mobile Plans",
                pageCategory: "Mobile",
                pageType: "Information"
            }
        });
    }

    render () {
        const RenderPlans = () => {
            return <Redirect push to='/mobilephone' />
        }

        const RenderFaqAndTerms = () => {
            return <FaqAndTerms faqUrl='/api/getContent/mobile/faqs' termsUrl='/api/getContent/mobile/terms' />
        }

        const RenderThreeGClosure = () => {
            return <ThreeGPolicy />
        }

        const isPlanPage = this.props.location.pathname === '/mobilephone'

        return (
            <div>
                <div ref={this.anchor} />
                <SubNavigationFloating items={this.subNav} url={this.props.match.url} anchor={this.anchor} dontFloat={!isPlanPage} />
                <Switch>
                    <Route exact path={this.props.match.url} component={Mobile4GPlans} />
                    <Route exact path={`${this.props.match.url}/plans`} render={RenderPlans} />
                    <Route exact path={`${this.props.match.url}/charges`} component={MobileCharges} />
                    {!isMobile ? <Route exact path={`${this.props.match.url}/coverage`} component={MobileCoverage} /> : ''}
                    <Route exact path={`${this.props.match.url}/international-rates`} component={MobileInternationalRates} />
                    <Route exact path={`${this.props.match.url}/plans-roaming`} component={MobileRoaming} />
                    <Route exact path={`${this.props.match.url}/faq-terms`} render={RenderFaqAndTerms} />
                    <Route exact path={`${this.props.match.url}/3g-closure`} render={RenderThreeGClosure} />
                </Switch>
            </div>
        )
    }
}

export default PageHOC(withRouter(Mobile), SERVICE_MOBILE)



// WEBPACK FOOTER //
// ./resources/js/pages/Mobile.js